export default __webpack_public_path__ + "static/media/codeberg-logo_icon_white.df62c12d.svg";